import React from 'react';
import PropTypes from 'prop-types';

export const ClockIcon = (({ width=48, height=48, color='#0083C6' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.01" x="0.111084" width="47.3333" height="48" fill="#F3F3F3"/>
            <path d="M23.758 4C12.8714 4 4.05554 12.96 4.05554 24C4.05554 35.04 12.8714 44 23.758 44C34.6644 44 43.5 35.04 43.5 24C43.5 12.96 34.6644 4 23.758 4ZM23.7778 40C15.0605 40 7.99998 32.84 7.99998 24C7.99998 15.16 15.0605 8 23.7778 8C32.495 8 39.5555 15.16 39.5555 24C39.5555 32.84 32.495 40 23.7778 40Z" fill={color}/>
            <path d="M24.7639 14H21.8055V26L32.1597 32.3L33.6389 29.84L24.7639 24.5V14Z" fill={color}/>
        </svg>
    );
});

ClockIcon.displayName = 'ClockIcon';
ClockIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    color: PropTypes.string
};
